import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter-slice";
import uiSlice from "../features/ui-slice";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    ui: uiSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
